import { Tooltip } from '@chakra-ui/react'
import React from 'react'

type CustomTooltipProps = {
  label: string
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ label, children }) => {
  return (
    <Tooltip
      hasArrow
      label={label}
      bg="gray.100"
      p={2}
      fontSize="xs"
      borderRadius="lg"
      color="black"
    >
      {children}
    </Tooltip>
  )
}

export default CustomTooltip
